(() => {
  document.querySelectorAll('[data-draft-detail]').forEach(root => {
    const entries = JSON.parse(root.querySelector('[data-whisky-draft]').textContent);
    const render = () => {
      const handle = decodeURIComponent(location.hash.slice(1)) || 'kakubin';
      const w = entries.find(item => item.handle === handle);
      if (!w) {
        root.querySelector('[data-detail-title]').textContent = '銘柄が見つかりません';
        root.querySelector('[data-detail-content]').hidden = true;
        return;
      }
      const text = (selector, value) => {root.querySelector(selector).textContent = value;};
      text('[data-detail-title]', w.name + 'に合うTARUBAR');
      text('[data-detail-category]', w.category);
      text('[data-detail-answer]', w.name + 'なら、まずは' + w.pairings[0].label);
      text('[data-detail-summary]', w.summary);
      text('[data-detail-drinking]', w.drinking);
      text('[data-detail-aging]', w.aging);
      document.title = w.name + 'に合うTARUBAR｜TARUBAR';
      const image = root.querySelector('[data-detail-bottle]');
      image.replaceChildren();
      const existing = root.querySelector(`[data-bottle-template="${w.handle}"]`);
      if (existing) image.append(existing.content.cloneNode(true));
      else {
        const mark = document.createElement('span'); mark.className = 'tbw-monogram'; mark.textContent = w.name.slice(0,1); mark.setAttribute('aria-hidden','true');
        const label = document.createElement('small'); label.textContent = 'ボトル画像準備中'; image.append(mark,label);
      }
      const cards = root.querySelector('[data-detail-pairs]'); cards.replaceChildren();
      const purposes = root.querySelector('[data-detail-purposes]'); purposes.replaceChildren();
      w.pairings.forEach(pair => {
        const template = root.querySelector(`[data-product-template="${pair.product_handle}"]`);
        const fragment = template.content.cloneNode(true);
        const card = fragment.querySelector('article'); card.id = pair.handle; card.classList.toggle('tbw-pair--first', pair.rank === 1);
        fragment.querySelector('[data-pair-label]').textContent = pair.label;
        const days = fragment.querySelector('[data-pair-days]'); days.textContent = pair.days ? pair.days + '日を目安に、好みで調整' : '';
        days.hidden = !pair.days;
        fragment.querySelector('[data-pair-rank]').textContent = pair.rank === 1 ? 'TOP 1 · 迷ったらこれ' : `TOP ${pair.rank}`;
        fragment.querySelector('[data-pair-purpose]').textContent = 'こんな人に：' + pair.purpose;
        fragment.querySelector('[data-pair-reason]').textContent = pair.reason;
        fragment.querySelector('[data-pair-drinking]').textContent = pair.drinking;
        cards.append(fragment);
        const button = document.createElement('button'); button.type = 'button'; button.className = 'tbw-chip';
        button.textContent = pair.purpose + ' ↓'; button.addEventListener('click',()=>card.scrollIntoView({behavior:'smooth',block:'start'})); purposes.append(button);
      });
      const sets = root.querySelector('[data-detail-set-cards]'); sets.replaceChildren();
      w.sets.forEach(id => {
        const template = root.querySelector(`[data-set-template="${id}"]`);
        if (template) {
          const fragment = template.content.cloneNode(true);
          fragment.querySelector('.tbw-tag').textContent = w.name + 'で試したい組み合わせを、まとめて。';
          sets.append(fragment);
        }
      });
      root.querySelector('[data-detail-sets]').hidden = !sets.children.length;
      const source = root.querySelector('[data-profile-source]'); source.hidden = !w.profile_source;
      if (w.profile_source) source.href = w.profile_source; else source.removeAttribute('href');
      root.querySelector('[data-detail-content]').hidden = false;
      root.dataset.whisky = handle;
    };
    render(); window.addEventListener('hashchange',render);
  });
})();

